import { JSX } from 'react';
import clsx from 'clsx';

import { useTheme } from '~/hooks/useTheme';

interface LogoProps {
  className?: string;
  /** Renders the mark only (no "Compounds.Dev" text) — the 68px sidebar rail / mobile top bar. */
  iconOnly?: boolean;
}

export function Logo({ className, iconOnly = false }: LogoProps): JSX.Element {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={clsx('shrink-0 flex items-center gap-3 text-lg md:text-xl font-logo', className)}
    >
      <img
        src={isDarkMode ? '/images/logo-light.svg' : '/images/logo.svg'}
        alt="Compounds.Dev"
        className="w-8 h-8 object-contain"
      />
      {!iconOnly && (
        <p>
          <span className="font-semibold">Compounds</span>
          <span className="font-normal">.Dev</span>
        </p>
      )}
    </div>
  );
}
